import { HttpClient } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { WindowService } from "@merri/common";
import { fromEvent, of, Subject } from "rxjs";
import { catchError, retry, takeUntil, tap } from "rxjs/operators";
import { AppConfigService, PRODUCT_NAME } from "src/app/core";
import { HelperMethods } from "src/app/shared";

interface FeaturedPartnersResponse {
  partners: FeaturedPartner[];
}

interface FeaturedPartner {
  logoUrl: string;
  partnerName: string;
}

@Component({
    selector: "app-homepage-featured-partners",
    templateUrl: "./homepage-featured-partners.component.html",
    styleUrls: ["./homepage-featured-partners.component.scss"],
    standalone: false
})
export class HomepageFeaturedPartnersComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<void> = new Subject<void>();

  loading: boolean;
  error: string;
  partners: FeaturedPartner[];

  carouselConfig: { numItems: number; itemGap: number; itemOffset: number } = {
    numItems: 4,
    itemGap: 40,
    itemOffset: 100,
  };

  readonly PRODUCT_NAME = PRODUCT_NAME;
  constructor(private appConfigService: AppConfigService, private windowService: WindowService, private http: HttpClient) {}

  ngOnInit() {
    this.buildCarouselConfig();

    fromEvent(window, "resize")
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: () => {
          this.buildCarouselConfig();
        },
      });

    this.loading = true;

    this.http
      .get<FeaturedPartnersResponse>(this.appConfigService.getConfig().getFeaturedPartnersApiUrl)
      .pipe(
        tap(response => {
          this.partners = (response.partners || []).sort((a, b) => {
            return HelperMethods.sortString(a.partnerName, b.partnerName);
          });
          this.error = null;
          this.loading = false;
        }),
        retry(2),
        catchError(() => {
          this.partners = null;
          this.error = "Something went wrong, please try again";
          this.loading = false;
          return of(false);
        }),
        takeUntil(this.destroyed$),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private buildCarouselConfig(): void {
    if (this.windowService.matchesMax(700)) {
      this.carouselConfig.numItems = 1;
    } else if (this.windowService.matchesMax(1000)) {
      this.carouselConfig.numItems = 2;
    } else if (this.windowService.matchesMax(1300)) {
      this.carouselConfig.numItems = 3;
    } else {
      this.carouselConfig.numItems = 4;
    }

    if (this.windowService.matchesMax(700)) {
      this.carouselConfig.itemOffset = 0;
    } else {
      this.carouselConfig.itemOffset = 100;
    }
  }
}
